import { useEventBus } from "./events.mjs";
import { TRACKING_EVENTS } from "./trackingHandlers.mjs";
const purchaseEvent = (emit) => (order) => {
  emit(TRACKING_EVENTS.PURCHASE, order);
};
const searchEvent = (emit) => (keyword) => {
  emit(TRACKING_EVENTS.SEARCH, keyword);
};
const completeRegistration = (emit) => (customer) => {
  emit(TRACKING_EVENTS.COMPLETE_REGISTRATION, customer);
};
const addToWishlist = (emit) => (product) => {
  emit(TRACKING_EVENTS.ADD_TO_WISH_LIST, product);
};
const onProduct = (emit) => (product) => {
  emit(TRACKING_EVENTS.ON_PRODUCT, product);
};
const productClick = (emit) => (product) => {
  emit(TRACKING_EVENTS.PRODUCT_CLICK, product);
};
const addToCart = (emit) => (cartItem) => {
  emit(TRACKING_EVENTS.ADD_TO_CART, cartItem);
};
const removeFromCart = (emit) => (cartItem) => {
  emit(TRACKING_EVENTS.PRODUCT_REMOVE_FROM_CART, cartItem);
};
const productView = (emit) => (product) => {
  emit(TRACKING_EVENTS.PRODUCT_VIEW, product);
};
const checkoutStep = (emit) => (step) => {
  emit(TRACKING_EVENTS.CHECKOUT_STEP, step);
};
const checkoutStepOption = (emit) => (step) => {
  emit(TRACKING_EVENTS.CHECKOUT_STEP_OPTION, step);
};
export const useGtmEvents = () => {
  const { emit } = useEventBus();
  return {
    purchaseEvent: purchaseEvent(emit),
    searchEvent: searchEvent(emit),
    completeRegistration: completeRegistration(emit),
    addToWishlist: addToWishlist(emit),
    onProduct: onProduct(emit),
    productClick: productClick(emit),
    addToCart: addToCart(emit),
    removeFromCart: removeFromCart(emit),
    productView: productView(emit),
    checkoutStep: checkoutStep(emit),
    checkoutStepOption: checkoutStepOption(emit)
  };
};
